<template>
<div class="chapter">
<div class="inner_page">
<h1 class="sigilnotintoc" id="pgepubid00000">A MAN OF MEANS</h1>
<h2 class="sigilnotintoc1" id="pgepubid00001">A SERIES OF SIX STORIES</h2>
<h2 class="sigilnotintoc1" id="calibre_pb_1">By Pelham Grenville Wodehouse and C. H. Bovill</h2>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Section001_split_000.vue?3927ac06